import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, AfterViewInit, AfterViewChecked } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { OurEduLocalStorageService } from './services/our-edu-local-storage.service';
import { AuthenticationService } from './services/authentication.service';
import {MessagingService} from './shared/messaging.service';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent implements OnInit {
  MENU_ITEMS: NbMenuItem[] = [
    // {
    //   title: 'Dashboard',
    //   icon: 'keypad-outline',
    //   link: '/pages/dashboard',
    // },
    {
      title: 'Subjects',
      icon: 'layout-outline',
      children: [
        {
          title: 'List Subjects',
          link: '/subjects',
        },
      ],
    }, {
      title: 'tasks',
      icon: 'edit-2-outline',
      link: '/tasks',
      children: [
        {
          title: 'tasks performance',
          link: '/task-performance/list',
          icon: 'layout-outline',
        },
        {
          title: 'tasks',
          link: '/task',
          icon: 'layout-outline',
        },
      ],
    }, {
      title: 'question reports',
      icon: 'file-remove',
      link: '/question-reports',
    },
  ];
  curretLang: string;
  show;
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private analytics: AnalyticsService, private translate: TranslateService, private authentication: AuthenticationService,
              private messagingService: MessagingService,
              private toastrService: NbToastrService) {

  }


  ngOnInit() {
    const defLang = OurEduLocalStorageService.getCurrentLanguage();
    this.translate.setDefaultLang(defLang);
    this.curretLang = this.translate.getDefaultLang();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // console.log(event)
      this.curretLang = event.lang;
      this.getMenuTranslation();
    });
    this.getMenuTranslation()
    this.analytics.trackPageViews();
    const el = document.getElementById('nb-global-spinner');
    if (el) {
      el.style['display'] = 'none';
    }

    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    this.show = this.messagingService.currentMessage;

  }

  getMenuTranslation() {
    this.translate.get(['dashboard', 'subjects', 'tasks', 'list_subjects', 'question_reports', 'task_performance', 'general_exams'])
      .subscribe((res: any[]) => {
        this.MENU_ITEMS = [
          // {
          //   title: res['dashboard'],
          //   icon: 'keypad-outline',
          //   link: '/pages/dashboard',
          // },
          {
            title: res['subjects'],
            icon: 'layout-outline',
            children: [
              {
                title: res['list_subjects'],
                link: '/subjects',
              },
            ],
          }, {
            title: res['tasks'],
            icon: 'edit-2-outline',
            link: '/tasks',
            children: [
              {
                title: res['task_performance'],
                link: '/task-performance/list',
                icon: 'layout-outline',
              },
              {
                title: res['tasks'],
                link: '/tasks',
                icon: 'layout-outline',
              },
            ],
          }, {
            title: res['question_reports'],
            icon: 'file-remove',
            link: '/question-reports',
          },{
            title: res['general_exams'],
            icon: 'activity-outline',
            link: '/general-exams',
          },
        ];
      })
  }
  showToast(position) {
    this.toastrService.show(
      'This is super toast message',
      `This is toast number: 3`,
      { position });
  }
}
